/**
 * @generated SignedSource<<f480ba3b3d3713e0ae0dbd734166be16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
import { FragmentRefs } from "relay-runtime";
export type EventSignUpCardWrapper_EventSignUp$data = {
  readonly bookings: {
    readonly count: number;
  } | null | undefined;
  readonly event: {
    readonly eventSeries: {
      readonly color: CustomColor;
      readonly facility: {
        readonly copyOverrides: {
          readonly course: {
            readonly plural: string;
          } | null | undefined;
        };
        readonly department: {
          readonly name: string;
          readonly type: DepartmentType;
        } | null | undefined;
        readonly name: string;
      };
      readonly name: string;
    };
    readonly eventSessions: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly courses: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly courseBucket: {
                  readonly name: string;
                } | null | undefined;
                readonly id: string;
                readonly name: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly endAt: string | null | undefined;
          readonly startAt: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
    readonly startOn: string;
    readonly tags: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
  readonly id: string;
  readonly " $fragmentType": "EventSignUpCardWrapper_EventSignUp";
};
export type EventSignUpCardWrapper_EventSignUp$key = {
  readonly " $data"?: EventSignUpCardWrapper_EventSignUp$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignUpCardWrapper_EventSignUp">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignUpCardWrapper_EventSignUp",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingConnection",
      "kind": "LinkedField",
      "name": "bookings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000
            }
          ],
          "concreteType": "EventTagConnection",
          "kind": "LinkedField",
          "name": "tags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventTagEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventTag",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "tags(first:1000)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "clientId",
              "variableName": "memberId"
            }
          ],
          "kind": "ScalarField",
          "name": "signUpStatusForClient",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSeries",
          "kind": "LinkedField",
          "name": "eventSeries",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plural",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Department",
                  "kind": "LinkedField",
                  "name": "department",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSessionConnection",
          "kind": "LinkedField",
          "name": "eventSessions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSessionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventSession",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseConnection",
                      "kind": "LinkedField",
                      "name": "courses",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CourseEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Course",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                (v1/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "CourseBucket",
                                  "kind": "LinkedField",
                                  "name": "courseBucket",
                                  "plural": false,
                                  "selections": (v2/*: any*/),
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventSignUp",
  "abstractKey": null
};
})();

(node as any).hash = "d972b566d7991d08336826d6461b49f5";

export default node;
